export default __webpack_public_path__ + "static/media/tank-scene.86d636bf.jpg";